var shpCustom = {
  cartItemsCountPanel: ".shpCartCount",
  cartItemsValuePanel: ".shpCartValue",

  shpProduct: null,
  shpCart: null,
  reloadEnabled: false,
  twoLevelZoom: false,

  baseURL: "",
  cookieInfoPeriod: 0,
  newsletterDismiss: 0,
  newsletterSubmit: 0,

  //##################################################################################################
  //	INITIALIZATION
  //##################################################################################################
  init: function () {
    shpCustom.baseURL = $('meta[name="shpBaseDir"]').attr("content");
    shpCustom.cookieInfoPeriod = $('meta[name="shpCookieInfoPeriod"]').attr(
      "content"
    );
    shpCustom.newsletterDismiss = $('meta[name="shpNewsletterDismiss"]').attr(
      "content"
    );
    shpCustom.newsletterSubmit = $('meta[name="shpNewsletterSubmit"]').attr(
      "content"
    );

    // Product images
    this.productImages();
    this.productMobileImages();

    //-------------------------------------------------------------------------------------------------
    //	cart
    //-------------------------------------------------------------------------------------------------
    $(".shpAdd2CartButton").on("click", function (event) {
      event.preventDefault();
      shpCustom.cartItemAdd(this);
    });

    $(".shpAddRecommended").on("click", function (event) {
      event.preventDefault();
      shpCustom.cartRecommendedAdd(this);
    });

    $(".shpAdd2CartButton").removeClass("d-none");

    shpCustom.initCartEvents();

    if (sessionStorage.getItem("shpShowCart")) {
      setTimeout(shpCustom.showCart(), 1000);
    }

    //-------------------------------------------------------------------------------------------------
    //	misc
    //-------------------------------------------------------------------------------------------------
    // blog, collections
    $("#shpLoadItemsList").on("click", function (event) {
      event.preventDefault();
      shpCustom.loadItemsList($(this).attr("href"));
    });

    // magic with open modals, change href
    this.hrefToModal();
    $("button[data-target]").on("click", function () {
      location.href = $(this).data("target");
    });
    $("#shpCustomShowInfo").on("hidden.bs.modal", function () {
      $(this).find(".modal-title").text("");
      $(this).find(".modal-body").html("");
    });

    // scroll2Element
    $("[data-scroll2element]").on("click", function (event) {
      event.preventDefault();
      shpCustom.scrollToElement($(this).data("scroll2element"));
    });

    // copy current URL to clipboard
    // show info about it
    $("[data-clipboard-share]").on("click", function (event) {
      event.preventDefault();
      let copyText = location.href;
      if (copyText) {
        navigator.clipboard.writeText(copyText);
        shpCustom.showInfo($(this).data("clipboard-share"), copyText);
      }
    });

    // checkbox group with only one ON
    $("[data-checkbox_group]").on("change", function (event) {
      event.preventDefault();
      shpCustom.chceckboxGroup($(this));
    });

    //-------------------------------------------------------------------------------------------------
    // check newsletter box
    //-------------------------------------------------------------------------------------------------
    if (!shpCustom.getCookie("newsletter_box")) {
      $("#shpNewsletterModalPanel").on("hidden.bs.modal", function (event) {
        if (shpCustom.newsletterDismiss > 0) {
          shpCustom.setCookie("newsletter_box", 1, shpCustom.newsletterDismiss); // close Newsletter window for X days
        } else {
          shpCustom.setCookie("newsletter_box", 1); // close Newsletter window for current session
        }
      });
      setTimeout(function () {
        $("#shpNewsletterModalPanel").modal("show");
      }, 2000);
    }
    $(".shpCustomNewsletterFormDiv form").on("submit", function () {
      // if submited any newsletter form
      if (shpCustom.newsletterSubmit > 0) {
        shpCustom.setCookie("newsletter_box", 1, shpCustom.newsletterSubmit); // close Newsletter window for X days
      } else {
        shpCustom.setCookie("newsletter_box", 1); // close Newsletter window for current session
      }
    });

    //-------------------------------------------------------------------------------------------------
    // check Cookie information
    //-------------------------------------------------------------------------------------------------
    if (!shpCustom.getCookie("cookies_box")) {
      $("#shpCookiesModalPanel button.accept").on("click", function () {
        $("#shpCookiesModalPanel").addClass("d-none");
        if (shpCustom.cookieInfoPeriod > 0) {
          shpCustom.setCookie("cookies_box", 1, shpCustom.cookieInfoPeriod); // close Cookie information for X days
        } else {
          shpCustom.setCookie("cookies_box", 1); // close Cookie information for current session
        }
      });
      $("#shpCookiesModalPanel").removeClass("d-none");
    }

    //-------------------------------------------------------------------------------------------------
    //	customer section
    //-------------------------------------------------------------------------------------------------
    //if ($('body.login-page').length>0) {
    // login / password reset-start
    $(".shpLoginFormToggle").on("click", function (event) {
      event.preventDefault();
      $(".shpLoginForm").toggle();
    });
    //}

    if ($("body.addresses-page").length > 0) {
      // addresses
      // show/hide address form
      $("[data-target_item_form_id]").on("click", function (event) {
        event.preventDefault();
        $("[data-item_form_id]").hide();
        let form_id = $(this).data("target_item_form_id");
        $("[data-item_form_id=" + form_id + "]").show();
      });
      // confirm address removal
      $("#shpAddressRemoveConfirmation").on("show.bs.modal", function (event) {
        var button = $(event.relatedTarget);
        $(this).find("form").attr("action", button.data("target"));
      });
      $("#shpAddressRemoveConfirmation").on(
        "hidden.bs.modal",
        function (event) {
          $(this).find("form").attr("action", "#");
        }
      );

      $('select[name="address[country]"]').each(function () {
        shpCustom.setSelectValue($(this));
      });
    }

    //-------------------------------------------------------------------------------------------------
    //	collection page / product list
    //-------------------------------------------------------------------------------------------------
    if ($("body.collection-page").length > 0) {
      // filters
      $("#filters button.apply").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyFilters();
      });

      $("#filters button.reset").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyFilters(true);
      });

      // tag-filters
      $("#tag-filters button.apply").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyTagFilters();
      });

      $("#tag-filters button.reset").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyTagFilters(true);
      });

      if ($("#tag-filters").data("start_mode") == "background") {
        $("#tag-filters input[type=checkbox], input[type=radio]").on(
          "click",
          function (event) {
            shpCustom.applyTagFilters();
          }
        );
      }

      shpCustom.initApplyFilters();
    }

    //-------------------------------------------------------------------------------------------------
    //	search page
    //-------------------------------------------------------------------------------------------------
    if ($("body.search-page").length > 0) {
      let query = shpCustom.getUrlParameter("q");
      if (query) {
        jQuery.each(query.split(/[\+\,\;]/), function (index, element) {
          $("#tag-filters")
            .find('input[type=checkbox][data-name="' + element.trim() + '"]')
            .prop("checked", true);
        });
      }

      // filters
      $("#filters button.apply").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyFilters();
      });

      $("#filters button.reset").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyFilters(true);
      });

      // tag-filters
      $("#tag-filters button.apply").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyTagSearchFilters();
      });

      $("#tag-filters button.reset").on("click", function (event) {
        event.preventDefault();
        shpCustom.reloadEnabled = true;
        shpCustom.applyTagSearchFilters(true);
      });

      shpCustom.initApplyFilters();
    }

    //-------------------------------------------------------------------------------------------------
    //	product page
    //-------------------------------------------------------------------------------------------------
    if ($("body.product-page").length > 0) {
      shpCustom.reloadEnabled = true;
      let product_handle = $("#product-object").data("handle");
      jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
        shpCustom.shpProduct = product;
        shpCustom.add2Visited(product);
        // get selected Variant ID
        shpCustom.shpProduct.selected_variant_id =
          $("#product-object").data("variant");
        jQuery.each(shpCustom.shpProduct.variants, function (index, element) {
          if (element.id == shpCustom.shpProduct.selected_variant_id) {
            // get selected Variant position
            shpCustom.shpProduct.selected_variant_index = index;
          }
        });
        $("body").trigger("updateProductInfo");
      });

      // productgroup selector (SWATCH)
      $("input[name=productgroup]").on("change", function () {
        let target = $(this).val();
        if (target && target != "#") {
          window.location.href = shpCustom.baseURL + $(this).val();
        }
      });

      shpCustom.initVariantSelectors();
    }

    //-------------------------------------------------------------------------------------------------
    //	video with mobile sources
    //-------------------------------------------------------------------------------------------------
    $(window).on("resize", function () {
      let w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      $("video[data-mobile]").each(function () {
        // change SRC for mobile
        if (
          $(this).children("source").data("mobile") != undefined &&
          w <= 768
        ) {
          if (
            $(this).children("source").data("mobile") !=
            $(this).children("source").attr("src")
          ) {
            $(this)
              .children("source")
              .attr("src", $(this).children("source").data("mobile"));
            $(this)[0].load();
          }
        } else if ($(this).children("source").data("desktop") != undefined) {
          if (
            $(this).children("source").data("desktop") !=
            $(this).children("source").attr("src")
          ) {
            $(this)
              .children("source")
              .attr("src", $(this).children("source").data("desktop"));
            $(this)[0].load();
          }
        }
      });
    });
    $(window).trigger("resize");

    //-------------------------------------------------------------------------------------------------
    //	simple variant switch
    //-------------------------------------------------------------------------------------------------
    $("[data-variant_simple_selector]").on("click", function (event) {
      //event.preventDefault();
      //event.stopPropagation();
      shpCustom.varaintSimpleSwitch(this);
    });

    //-------------------------------------------------------------------------------------------------
    //	ui-groups
    //	(a group of checkboxes controlling hidden inputs)
    //-------------------------------------------------------------------------------------------------
    $("[data-ui_group]").on("change", function (event) {
      event.preventDefault();
      shpCustom.uiGroupRun(this);
    });

    window.shpCustom = shpCustom;
  },

  //##################################################################################################
  //	module functions
  //##################################################################################################

  show: function (element) {
    $(element).get(0).style.removeProperty("display");
  },

  hide: function (element) {
    $(element).hide();
  },

  //-------------------------------------------------------------------------------------------------
  //	cookies
  //-------------------------------------------------------------------------------------------------
  setCookie: function (cname, cvalue) {
    var expires = "";
    var path = "path=/";
    if (arguments[2]) {
      var d = new Date();
      d.setTime(d.getTime() + arguments[2] * 24 * 60 * 60 * 1000);
      expires = "expires=" + d.toGMTString() + "; ";
    }
    document.cookie = "SHP_" + cname + "=" + cvalue + "; " + expires + path;
  },

  getCookie: function (cname) {
    var name = "SHP_" + cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  },

  //-------------------------------------------------------------------------------------------------
  //	misc
  //-------------------------------------------------------------------------------------------------

  // change a.href with href #modal_id (added in Theme Customization) to button witch opens that modal
  hrefToModal: function () {
    $(".modal").each(function () {
      let id = $(this).attr("id");
      $("a[href='#" + id + "']").each(function () {
        $(this).attr("href", "#");
        $(this).attr("data-bs-toggle", "modal").data("bs-toggle", "modal");
        $(this)
          .attr("data-bs-target", "#" + id)
          .data("bs-target", "#" + id);
      });
    });
  },

  /**
   *  @brief Loads next page of items. Should be bined to <a href="url2load"> button
   *
   *  @param [in] url2load 					url to load next page (href)
   *  @param [in] successCallback 	callback function
   *  @param [in] clearContainer 		flag: clear Items container before load?
   *
   *  @details
   *  	- items are placed in #shpItemsList2Load-container (next are append to old one)
   *  	- panel with loading - #shpItemsList2Load-count (old panel content is replaced by next)
   *
   */
  loadItemsList: function (url2load) {
    $("body").addClass("shpItemsLoading");
    let successCallback = arguments[1] ? arguments[1] : "";
    let clearContainer = arguments[2] ? arguments[2] : "";
    $.ajax({
      url: url2load,
      type: "GET",
    }).done(function (data) {
      // 1. load itemsList into page
      if (clearContainer) {
        $("#shpItemsList2Load-container").html(
          $(data).find("#shpItemsList2Load-container").html()
        );
      } else {
        $("#shpItemsList2Load-container").append(
          $(data).find("#shpItemsList2Load-container").html()
        );
      }
      // 2. refresh itemsListCount
      $("#shpItemsList2Load-count").html(
        $(data).find("#shpItemsList2Load-count").html()
      );

      // 3. attach loadItemsList method
      $("#shpLoadItemsList").on("click", function (event) {
        event.preventDefault();
        shpCustom.loadItemsList($(this).attr("href"), successCallback);
      });

      // 4. run callback
      if (typeof successCallback !== "function") {
        successCallback = false;
      }
      if (successCallback) {
        successCallback(data);
      }

      // 5. refresh shpAdd2CartButton click event (in case new buttons)
      $(".shpAdd2CartButton").each(function () {
        $(this).off("click");
      });
      $(".shpAdd2CartButton").on("click", function (event) {
        event.preventDefault();
        shpCustom.cartItemAdd(this);
      });
      $(".shpAdd2CartButton").removeClass("d-none");

      $("body").removeClass("shpItemsLoading");
      $("body").trigger("loadItemsList");
    });
  },

  getUrlParameter: function (sParam) {
    let sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  },

  setSelectValue: function (selectElement) {
    let selectValue = $(selectElement).data("default");
    if (selectValue) {
      $(selectElement)
        .find("option")
        .each(function () {
          if ($(this).text() == selectValue) {
            $(this).prop("selected", true);
            return false;
          }
        });
    }
  },

  showInfo: function (infoTitle, infoText) {
    if ($("#shpCustomShowInfo").length > 0) {
      let infoModal = $("#shpCustomShowInfo");
      $(infoModal).find(".modal-title").text(infoTitle);
      $(infoModal).find(".modal-body").html(infoText);
      $(infoModal).modal("show");
    } else {
      alert(infoTitle + ":" + String.fromCharCode(13, 10) + infoText);
    }
  },

  scrollToElement: function (elSelector) {
    if ($(elSelector).length > 0) {
      let position = $(elSelector).position();
      let headerOffset = $("header").length > 0 ? $("header").height() : 0;
      let marginHeight = 5;

      position = parseInt(position.top) - headerOffset - marginHeight;
      document.body.scrollTop = position; // For Safari
      document.documentElement.scrollTop = position; // For Chrome, Firefox, IE and Opera
    }
  },

  uiGroupRun: function (element) {
    if ($('[data-ui_group="' + $(element).data("ui_group") + '"]').length > 1) {
      let mainElement = $('[data-ui="' + $(element).data("ui_group") + '"]');
      let mainValue = $(element).prop("checked") ? $(element).val() : "";
      if ($(mainElement).length > 0) {
        $(mainElement).val(mainValue);
        $('[data-ui_group="' + $(element).data("ui_group") + '"]').each(
          function () {
            $(this).prop("checked", $(this).val() == mainValue);
          }
        );
        $(mainElement).change();
      }
    }
  },

  gotoURL: function (element) {
    location.href = encodeURI($(element).data("url"));
  },

  //-------------------------------------------------------------------------------------------------
  //	collection page / product list
  //-------------------------------------------------------------------------------------------------

  initApplyFilters: function () {
    $("#filters button.apply").on("click", function (event) {
      event.preventDefault();
      shpCustom.reloadEnabled = true;
      shpCustom.applyFilters();
    });

    $("#filters button.reset").on("click", function (event) {
      event.preventDefault();
      shpCustom.reloadEnabled = true;
      shpCustom.applyFilters(true);
    });

    if ($("#filters").data("start_mode") == "background") {
      $("#filters input[type=checkbox], input[type=radio]").on(
        "change",
        function (event) {
          event.preventDefault();
          shpCustom.applyFilters();
        }
      );
    }
  },

  /**
   *  @brief function to assign submit (read filter checkboxes, send request and get response)
   */
  applyFilters: function () {
    let filtersPanel = $("#filters");
    let targetUrl = "";

    if (filtersPanel.data("collection_url")) {
      let collectionURL =
        shpCustom.baseURL + filtersPanel.data("collection_url") + "/";
      let filtersList = [];

      let paramsURL = filtersPanel.data("url_params");
      if (paramsURL) {
        filtersList.push(paramsURL);
      }

      if (arguments[0] !== true) {
        // true => reset filters
        // filters are defined by checkbox inside filtersPanel
        filtersPanel
          .find("input[type=checkbox], input[type=radio]")
          .each(function (index) {
            if (
              $(this).attr("name") != "sort_by" &&
              $(this).prop("checked") &&
              $(this).prop("disabled") == false
            ) {
              filtersList.push(
                $(this).attr("name") + "=" + encodeURI($(this).val())
              );
            }
          });
      } else {
        filtersPanel
          .find("input[type=checkbox], input[type=radio]")
          .each(function (index) {
            $(this).prop("checked", false);
          });
      }

      if (filtersPanel.data("collection_sortby")) {
        // sorting is defined elsewhere
        filtersList.push("sort_by=" + filtersPanel.data("collection_sortby"));
      } else {
        // sorting is defined by checkbox inside filtersPanel
        if (arguments[0] !== true) {
          // true => reset sorting
          let sort_order = filtersPanel
            .find("input[name=sort_by]:checked")
            .val();
          if (sort_order) {
            filtersList.push("sort_by=" + sort_order);
          }
        }
      }
      targetUrl = collectionURL;
      if (filtersList.length > 0) {
        targetUrl = targetUrl + "?" + filtersList.join("&");
      }

      if (
        filtersPanel.data("run_mode") == "reload" &&
        shpCustom.reloadEnabled
      ) {
        window.location.href = targetUrl;
      } else if (filtersPanel.data("run_mode") == "ajax") {
        // update URL (without reloading)
        history.pushState("page", "Collection page", targetUrl);

        // update filters panel
        $.ajax({
          url:
            targetUrl +
            (targetUrl == collectionURL ? "?" : "&") +
            "sections=collection-filters",
          type: "GET",
        }).done(function (data) {
          // 1. load into page elements signed data-filterItem2load='element_index'
          $(data["collection-filters"])
            .find("[data-filter_item2load]")
            .each(function () {
              if ($(this).data("filter_item2load")) {
                $("#filters")
                  .find(
                    '[data-filter_item2load="' +
                      $(this).data("filter_item2load") +
                      '"]'
                  )
                  .html($(this).html());
                $("#filters")
                  .find(
                    '[data-filter_item2load="' +
                      $(this).data("filter_item2load") +
                      '"]'
                  )
                  .attr("class", $(this).attr("class"));
              }
            });
          shpCustom.initApplyFilters();
        });

        // load items list
        shpCustom.loadItemsList(targetUrl, false, true);
      }
    }
    return targetUrl;
  },

  /**
   *  @brief function to assign submit (read tag checkboxes and send request)
   */
  applyTagFilters: function () {
    let filtersPanel = $("#tag-filters");
    let targetUrl = "";

    if (filtersPanel.data("collection_url")) {
      let collectionURL =
        shpCustom.baseURL + filtersPanel.data("collection_url") + "/";
      let filtersList = [];
      let sort_url = "";

      if (arguments[0] !== true) {
        // true => reset filters
        let externalFilters = false;

        let filterDataset = filtersPanel.data();
        if (filterDataset != undefined) {
          for (const property in filterDataset) {
            if (property.substring(0, 17) == "collection_filter") {
              // filters are defined elsewhere and kept in filtersPanel.data()
              externalFilters = true;
              if (filterDataset[property] != "") {
                filtersList.push(filterDataset[property]);
              }
            }
          }
        }

        if (!externalFilters) {
          // filters are defined by checkbox inside filtersPanel
          filtersPanel
            .find("input[type=checkbox], input[type=radio]")
            .each(function (index) {
              if (
                $(this).attr("name") != "sort_by" &&
                $(this).prop("checked") &&
                $(this).prop("disabled") == false
              ) {
                filtersList.push($(this).val());
              }
            });
        }
      } else {
        filtersPanel
          .find("input[type=checkbox], input[type=radio]")
          .each(function (index) {
            $(this).prop("checked", false);
          });
      }

      if (filtersPanel.data("collection_sortby")) {
        // sorting is defined elsewhere
        sort_url = "?sort_by=" + filtersPanel.data("collection_sortby");
      } else {
        // sorting is defined by checkbox inside filtersPanel
        if (arguments[0] !== true) {
          // true => reset sorting
          let sort_order = filtersPanel
            .find("input[name=sort_by]:checked")
            .val();
          if (sort_order) {
            sort_url = "?sort_by=" + sort_order;
          }
        }
      }

      targetUrl = collectionURL + filtersList.join("+") + sort_url;

      if (
        filtersPanel.data("run_mode") == "reload" &&
        shpCustom.reloadEnabled
      ) {
        window.location.href = targetUrl;
      } else if (filtersPanel.data("run_mode") == "ajax") {
        // update URL (without reloading)
        history.pushState("page", "Collection page", targetUrl);
        shpCustom.loadItemsList(targetUrl, false, true);
      }
    }
    return targetUrl;
  },

  //-------------------------------------------------------------------------------------------------
  //	search page
  //-------------------------------------------------------------------------------------------------

  applyTagSearchFilters: function () {
    let filtersPanel = $("#tag-filters");
    let targetUrl = "";

    if (filtersPanel.data("collection_url")) {
      let searchURL = shpCustom.baseURL + filtersPanel.data("collection_url");
      let paramsList = [];

      let sort_url = "";
      if (filtersPanel.data("collection_sortby")) {
        // sorting is defined elsewhere
        sort_url = "sort_by=" + filtersPanel.data("collection_sortby").trim();
      } else {
        // sorting is defined by checkbox inside filtersPanel
        if (arguments[0] !== true) {
          // true => reset sorting
          let sort_order = filtersPanel
            .find("input[name=sort_by]:checked")
            .val();
          if (sort_order) {
            sort_url = "sort_by=" + sort_order.trim();
          }
        }
      }
      if (sort_url) {
        paramsList.push(sort_url);
      }

      if (filtersPanel.data("search_type")) {
        paramsList.push("type=" + filtersPanel.data("search_type").trim());
      }

      let filtersList = [];
      if (filtersPanel.data("search_q")) {
        filtersList.push(filtersPanel.data("search_q").trim());
      }
      if (arguments[0] !== true) {
        // true => reset filters (but only TAGS)

        let externalFilters = false;
        let filterDataset = filtersPanel.data();

        if (filterDataset != undefined) {
          for (const property in filterDataset) {
            if (property.substring(0, 17) == "collection_filter") {
              // filters are defined elsewhere and kept in filtersPanel.data()
              externalFilters = true;
              if (filterDataset[property] != "") {
                filtersList.push(filterDataset[property]);
              }
            }
          }
        }

        if (!externalFilters) {
          // filters are defined by checkbox inside filtersPanel
          filtersPanel
            .find("input[type=checkbox], input[type=radio]")
            .each(function (index) {
              if (
                $(this).attr("name") != "sort_by" &&
                $(this).prop("checked") &&
                $(this).prop("disabled") == false
              ) {
                filtersList.push($(this).val());
              }
            });
        }
      } else {
        filtersPanel
          .find("input[type=checkbox], input[type=radio]")
          .each(function (index) {
            $(this).prop("checked", false);
          });
      }
      paramsList.push("q=" + filtersList.join("+"));

      targetUrl = searchURL + "?" + paramsList.join("&");

      if (
        filtersPanel.data("run_mode") == "reload" &&
        shpCustom.reloadEnabled
      ) {
        window.location.href = targetUrl;
      } else if (filtersPanel.data("run_mode") == "ajax") {
        // update URL (without reloading)
        history.pushState("page", "Search result", targetUrl);
        shpCustom.loadItemsList(targetUrl, false, true);
      }
    }
    return targetUrl;
  },

  //-------------------------------------------------------------------------------------------------
  //	product
  //-------------------------------------------------------------------------------------------------

  productImages: function () {
    $(".js-product-desktop-thumbnails").not(".slick-initialized").slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    }
  ]});

    $(".js-product-thumbnail").on("click", function () {
      var id = $(this).attr("data-id");
      $(".js-product-thumbnail").removeClass("active");
      $(this).addClass("active");
      $(".js-product-main-image").removeClass("active");
      $(".js-product-main-image[data-id='" + id + "']").addClass("active");
      return false;
    });
  },

  productMobileImages: function () {
    $(".js-product-mobile-gallery").not(".slick-initialized").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: true,
    });
  },

  fixedDiscountAndAddToBag: function () {
    const $discountAndAddToBag = $(".js-discount-and-add-to-bag");
    const $navTabs = $(".js-nav-tabs");
    let lastScrollTop = $(window).scrollTop();
    const discountHeight = $discountAndAddToBag.outerHeight();

    $(window).on("scroll", function () {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 767) {
        const navTabsRect = $navTabs[0].getBoundingClientRect();
        const currentScrollTop = $(window).scrollTop();

        if (currentScrollTop > lastScrollTop) {
          if (navTabsRect.top <= window.innerHeight) {
            if (!$discountAndAddToBag.hasClass("fixed")) {
              $discountAndAddToBag.addClass("fixed");
            }
          }
        } else {
          if (navTabsRect.top > window.innerHeight - discountHeight) {
            if ($discountAndAddToBag.hasClass("fixed")) {
              $discountAndAddToBag.removeClass("fixed");
            }
          }
        }
        lastScrollTop = currentScrollTop;
      } else {
        $discountAndAddToBag.removeClass("fixed");
      }
    });
  },

  initVariantSelectors: function () {
    // sticky add to cart button
    this.fixedDiscountAndAddToBag();

    $("#product-object input[name=selling_plan]").val(
      $("#product-object .single-offer.active").data("selling-plan-id")
    );

    // many variants selectors (based on CHECKBOXES)
    $("input.variantSelector").on("click", function (e) {
      e.preventDefault();
      let cartForm = $(this).parents("form");
      let newVariantID = $(this).val();
      let currentID = $(this).attr("id");

      $(cartForm)
        .find("input.variantSelector")
        .each(function () {
          if (
            $(this).val() == newVariantID &&
            $(this).attr("id") != currentID
          ) {
            $(this).prop("checked", true);
          }
        });
      jQuery.each(shpCustom.shpProduct.variants, function (index, element) {
        if (element.id == newVariantID) {
          shpCustom.updateVariantInfo(element);
        }
      });
    });

    // One variant selector (based on SELECT)
    $("select.variantSelector").on("change", function () {
      let cartForm = $(this).parents("form");
      let newVariantID = $(this).find("option:selected").val();
      let currentID = $(this).attr("id");

      jQuery.each(shpCustom.shpProduct.variants, function (index, element) {
        if (element.id == newVariantID) {
          shpCustom.updateVariantInfo(element);
        }
      });
    });

    this.updateGiftsAndDiscounts();
  },

  updateGiftsAndDiscounts: function () {
    var subscribeModal = $(".js-subscribe-modal");

    if (subscribeModal && !subscribeModal.hasClass("d-none")) {
      $(".js-selling-plan-promo").addClass("d-none");
      $(".js-compare-price-promo").removeClass("d-none");
      $("#product-object input[name=selling_plan]").val("");
      $("#product-object input[name=gift_id]").val("");
      $(".shpAdd2CartButton [data-default-price]").each(function () {
        $(this).html($(this).data("default-price"));
        $(this)
          .attr("data-current_price_value", $(this).data("default-price_value"))
          .data("current_price_value", $(this).data("default-price_value"));
      });
    }

    if (".js-subscribe-gift".length) {
      const variantPrice = $(
        ".shpAdd2CartButton [data-compare-price_value]"
      ).data("compare-price_value");
      const variantCurrentNotSubscribePrice = $(
        ".shpAdd2CartButton [data-compare-price_value]"
      ).data("default-price_value");
      const variantCurrentSubscribePrice = $(
        "#subscribe .single-offer.active .plan-price"
      ).data("value");
      const shippingPrice = $(".js-subscribe-gift[data-shipping-price]").data(
        "shipping-price"
      );
      const firstGiftPrice = $(
        ".js-subscribe-gift[data-first-free-gift-price]"
      ).data("first-free-gift-price");
      const secondGiftPrice = $(
        ".js-subscribe-gift[data-second-free-gift-price]"
      ).data("second-free-gift-price");

      const firstNotSubscribeSummaryPrice = (
        Number(variantPrice) + Number(shippingPrice)
      ).toFixed(2);
      const secondNotSubscribeSummaryPrice = (
        Number(variantPrice) + Number(shippingPrice)
      ).toFixed(2);

      const firstSubscribeSummaryPrice = (
        Number(variantPrice) +
        Number(shippingPrice) +
        Number(firstGiftPrice)
      ).toFixed(2);
      const secondSubscribeSummaryPrice = (
        Number(variantPrice) +
        Number(shippingPrice) +
        Number(firstGiftPrice) +
        Number(secondGiftPrice)
      ).toFixed(2);

      const firstVariantNotSubscribeSaving = (
        Number(variantPrice) - Number(variantCurrentNotSubscribePrice)
      ).toFixed(2);

      const secondVariantNotSubscribeSaving = (
        Number(firstNotSubscribeSummaryPrice) -
        Number(variantCurrentNotSubscribePrice)
      ).toFixed(2);

      const thirdVariantNotSubscribeSaving = (
        Number(secondNotSubscribeSummaryPrice) -
        Number(variantCurrentNotSubscribePrice)
      ).toFixed(2);

      const firstVariantSubscribeSaving = (
        Number(variantPrice) - Number(variantCurrentSubscribePrice)
      ).toFixed(2);

      const secondVariantSubscribeSaving = (
        Number(firstSubscribeSummaryPrice) -
        Number(variantCurrentSubscribePrice)
      ).toFixed(2);

      const thirdVariantSubscribeSaving = (
        Number(secondSubscribeSummaryPrice) -
        Number(variantCurrentSubscribePrice)
      ).toFixed(2);

      $(".js-discount-percentage").text(
        $(
          ".variant-item.current .js-selling-plan-promo[data-percentage-discount]"
        ).data("percentage-discount") || 0
      );

      let moneyFormat = shpTheme.money.moneyFormat + "";

      $("input.variantSelector").each(function () {
        if ($(this).prop("checked")) {
          const checkedVariant = $(this).data("option-name");

          $(".js-subscribe-gift").addClass("disabled");
          $(".js-free-shipping").removeClass("d-none");

          if (checkedVariant == "12") {
            if (!subscribeModal.hasClass("d-none")) {
              $(".js-discount-summary").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(firstVariantNotSubscribeSaving).format("0,0.00")
                )
              );
            } else {
              $('.js-subscribe-gift[data-related-variant="12"]').removeClass(
                "disabled"
              );
              $(".js-free-shipping").addClass("d-none");
              $(".js-subscribe-old-price").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(variantPrice).format("0,0.00")
                )
              );
              $(".js-discount-summary").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(firstVariantSubscribeSaving).format("0,0.00")
                )
              );
            }
          }
          if (checkedVariant == "24") {
            if (!subscribeModal.hasClass("d-none")) {
              $(".js-discount-summary").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(secondVariantNotSubscribeSaving).format("0,0.00")
                )
              );
            } else {
              $('.js-subscribe-gift[data-related-variant="24"]').removeClass(
                "disabled"
              );
              $('.js-subscribe-gift[data-related-variant="12"]').removeClass(
                "disabled"
              );
              $(".js-subscribe-old-price").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(firstSubscribeSummaryPrice).format("0,0.00")
                )
              );
              $(".js-discount-summary").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(secondVariantSubscribeSaving).format("0,0.00")
                )
              );
            }
          }
          if (checkedVariant == "48") {
            if (!subscribeModal.hasClass("d-none")) {
              $(".js-discount-summary").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(thirdVariantNotSubscribeSaving).format("0,0.00")
                )
              );
            } else {
              $(".js-subscribe-gift").removeClass("disabled");
              $(".js-subscribe-old-price").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(secondSubscribeSummaryPrice).format("0,0.00")
                )
              );
              $(".js-discount-summary").html(
                moneyFormat.replace(
                  "{{amount}}",
                  numeral(thirdVariantSubscribeSaving).format("0,0.00")
                )
              );
            }
          }
        }
      });
    }
  },

  /**
   * @brief	switching variants implemented as controlling the visibility of already prepared elements
   *				suitable for simple elements, panels
   */
  varaintSimpleSwitch: function (element) {
    let container = $(element).parents("[data-variant_simple_container]");
    let variant_id = $(element).data("variant_id");

    if (container.length > 0 && variant_id != undefined) {
      $(container).find("[data-variant_simple_selector]").removeClass("active");
      $(element).addClass("active");

      $(container).find("[data-selected_variant_id]").addClass("d-none");
      $(container)
        .find("[data-selected_variant_id=" + variant_id + "]")
        .removeClass("d-none");

      jQuery.each(shpCustom.shpProduct.variants, function (index, element) {
        if (element.id == variant_id) {
          if (element.available) {
            $(container)
              .find("[data-selected_variant_notavailable]")
              .addClass("d-none");
            $(container)
              .find("[data-selected_variant_available]")
              .removeClass("d-none");
          } else {
            $(container)
              .find("[data-selected_variant_available]")
              .addClass("d-none");
            $(container)
              .find("[data-selected_variant_notavailable]")
              .removeClass("d-none");
          }
        }
      });
    }
  },

  /**
   * @brief	reloading to variant page
   *				variant idetyfication based on options list
   */
  reload2Variant: function (option1, option2, option3) {
    let goodID_123 = null;
    let goodID_12 = null;

    let firstOption1ID = null;
    let firstOption2ID = null;
    let firstOption3ID = null;

    let selectedVariant =
      shpCustom.shpProduct.variants[
        shpCustom.shpProduct.selected_variant_index
      ];
    jQuery.each(shpCustom.shpProduct.variants, function (index, element) {
      if (!firstOption1ID && element.options[0] == option1) {
        firstOption1ID = element.id;
      }
      if (!firstOption2ID && element.options[1] == option2) {
        firstOption2ID = element.id;
      }
      if (!firstOption3ID && element.options[2] == option3) {
        firstOption3ID = element.id;
      }

      if (
        !goodID_12 &&
        element.options[0] == option1 &&
        element.options[1] == option2
      ) {
        goodID_12 = element.id;
      }
      if (
        !goodID_123 &&
        element.options[0] == option1 &&
        element.options[1] == option2 &&
        element.options[2] == option3
      ) {
        goodID_123 = element.id;
      }
    });

    let goodID = goodID_123 ? goodID_123 : goodID_12;

    if (!goodID) {
      if (firstOption1ID) {
        goodID = firstOption1ID;
      } else if (firstOption2ID) {
        goodID = firstOption2ID;
      } else {
        goodID = firstOption3ID;
      }
    }
    if (goodID) {
      //if (shpCustom.reloadEnabled) {
      window.location.href =
        shpCustom.baseURL + shpCustom.shpProduct.url + "?variant=" + goodID;
      //}
    }
  },

  /**
   *  @brief from changed option calculate new selected Variant
   *
   *  @param [in] optionID		option.position
   *  @param [in] optionValue option value for Variant
   *  @return slected Variant Object
   *
   */
  setNewVariantByOptions: function (optionID, optionValue) {
    let newVariant = false;
    let currentVariant =
      shpCustom.shpProduct.variants[
        shpCustom.shpProduct.selected_variant_index
      ];
    let currentFeatures = {
      option1: null,
      option2: null,
      option3: null,
    };
    if (currentVariant) {
      currentFeatures = {
        option1: currentVariant.option1,
        option2: currentVariant.option2,
        option3: currentVariant.option3,
      };
    }
    // get clone of currentFeatures but with changed option
    let newFeatures = Object.assign({}, currentFeatures);
    newFeatures[optionID] = optionValue;

    jQuery.each(shpCustom.shpProduct.variants, function (index, element) {
      if (
        element.option1 == newFeatures.option1 &&
        element.option2 == newFeatures.option2 &&
        element.option3 == newFeatures.option3
      ) {
        newVariant = Object.assign({}, element);
        newVariant["index"] = index;
      }
    });

    shpCustom.updateVariantInfo(newVariant);
  },

  /**
   *  @brief load data of new Variant into HTML Elements (JS OR Section Rendering API)
   *
   *  @param [in] newVariant 	new variant data
   */
  updateVariantInfo: function (newVariant) {
    const mode = "load";

    if (newVariant != false) {
      // variant ID
      $("#product-object")
        .attr("data-variant", newVariant.id)
        .data("variant", newVariant.id);
      $("#product-object input[name=id]").val(newVariant.id);
      let sellingPlan = "";
      let variantName = $(`#variant-${newVariant.id}`).data("option-name");
      let freeGiftId = $(".js-product-gift")
        .filter(function () {
          return Number($(this).data("related-variant")) <= Number(variantName);
        })
        .map(function () {
          return $(this).data("free-gift-id");
        })
        .get()
        .filter(function (id) {
          return id !== undefined && id !== null && id !== "";
        })
        .join(",");
      $("#product-object input[name=gift_id]").val(freeGiftId);

      if (mode == "load") {
        $("#product-object .shpAdd2CartButton").prop("disabled", true);
        // loading newVariant using Section AJAX API
        if ($("#product-object input[name=selling_plan]").val() != "") {
          sellingPlan =
            "&selling_plan=" +
            $("#product-object input[name=selling_plan]").val();
        }

        var productTemplate = "";
        if ($("body").hasClass("product-merch")) {
          productTemplate = "merch-product";
        } else if ($("body").hasClass("product-peach")) {
          productTemplate = "peach-product";
        } else {
          productTemplate = "bundle-builder";
        }

        $.ajax({
          url:
            $("#product-object").data("baseurl") +
            "?sections=" +
            productTemplate +
            "&variant=" +
            newVariant.id +
            sellingPlan,
          type: "GET",
        }).fail(function () {
          $("#product-object .shpAdd2CartButton").prop("disabled", !newVariant.available);
        }).done(function (data) {
          // 1. load html into page
          $("#shpProductVariant-container").html(
            $(data[productTemplate]).find("#shpProductVariant-container").html()
          );
          $("#subscribe").html(
            $(data[productTemplate]).find("#subscribe").html()
          );
          $("#subscribe-add-to-bag").html(
            $(data[productTemplate]).find("#subscribe-add-to-bag").html()
          );
          if ($("body").hasClass("product-merch") || $("body").hasClass("product-peach")) {
            $("#discount-summary").html(
              $(data[productTemplate]).find("#discount-summary").html()
            );
          }
          shpCustom.initVariantSelectors();

          $(".shpAdd2CartButton")
            .off("click")
            .on("click", function (event) {
              event.preventDefault();
              shpCustom.cartItemAdd(this);
            });
          
          const $add2cart = $("#product-object .shpAdd2CartButton");

          if (newVariant.available) {
            $add2cart.prop("disabled", false);
            $add2cart.find("[data-unavailable_label]").hide();
            $add2cart.find("[data-add2cart_label]").show();
          } else {
            $add2cart.prop("disabled", true);
            $add2cart.find("[data-add2cart_label]").hide();
            $add2cart.find("[data-unavailable_label]").show();
          }

          shpCustom.shpProduct.selected_variant_index = newVariant.index;
          history.pushState(
            "page",
            shpCustom.shpProduct.title,
            $("#product-object").data("baseurl") + "?variant=" + newVariant.id
          );
          $("body").trigger("updateVariantInfo");

          if (!$(".js-subscribe-modal").hasClass("d-none")) {
            $("#product-object input[name=selling_plan]").val("");
            $("#product-object input[name=gift_id]").val("");
            $(".shpAdd2CartButton [data-default-price]").each(function () {
              $(this).html($(this).data("default-price"));
              $(this)
                .attr(
                  "data-current_price_value",
                  $(this).data("default-price_value")
                )
                .data(
                  "current_price_value",
                  $(this).data("default-price_value")
                );
            });
          }
        });
      } else {
        // loading a newVariant by updating predefined elements based on data in the newVariant object

        // price
        let moneyFormat = shpTheme.money.moneyFormat + "";
        $("#product-object .product-standard-price").html(
          moneyFormat.replace(
            "{{amount}}",
            numeral(newVariant.price / 100).format("0,0.00")
          )
        );
        if (newVariant.compare_at_price > newVariant.price) {
          $("#product-object .product-compare-price").html(
            moneyFormat.replace(
              "{{amount}}",
              numeral(newVariant.compare_at_price / 100).format("0,0.00")
            )
          );
        } else {
          $("#product-object .product-compare-price").html("");
        }

        // AddToCart buttons
        let Add2Cart = $("#product-object .shpAdd2CartButton");
        if (newVariant.available) {
          $(Add2Cart).prop("disabled", false);
          $(Add2Cart).find("[data-unavailable_label]").hide();
          $(Add2Cart).find("[data-add2cart_label]").show();
          //$(Add2Cart).find('[data-add2cart_label]').html(shpTheme.strings.addToCart);
        } else {
          $(Add2Cart).prop("disabled", true);
          $(Add2Cart).find("[data-add2cart_label]").hide();
          $(Add2Cart).find("[data-unavailable_label]").show();
          //$(Add2Cart).find('[data-add2cart_label]').html(shpTheme.strings.unavailableProduct);
        }

        // image - scroll to variant image
        if (newVariant.featured_image && $(".product-carousel").length > 0) {
          if ($(".product-carousel.flickity-enabled").length > 0) {
            // Flickity
            $(".product-carousel .carousel-cell").each(function (index) {
              if (newVariant.featured_image.id == $(this).data("src_id")) {
                $(".product-carousel").flickity("select", index, false, true);
              }
            });
          } else if ($(".product-carousel.slick-initialized").length > 0) {
            // Slick
            $(".product-carousel .slick-slide")
              .not(".slick-cloned")
              .each(function () {
                if (newVariant.featured_image.id == $(this).data("src_id")) {
                  $(".product-carousel").slick(
                    "slickGoTo",
                    $(this).data("slick-index"),
                    true
                  );
                }
              });
          }
        }

        shpCustom.shpProduct.selected_variant_index = newVariant.index;
        history.pushState(
          "page",
          shpCustom.shpProduct.title,
          $("#product-object").data("baseurl") + "?variant=" + newVariant.id
        );
        $("body").trigger("updateVariantInfo");
      }
    } else {
      shpCustom.showInfo(
        shpTheme.strings.unknownVariantTitle,
        shpTheme.strings.unknownVariantMessage
      );
    }
  },

  add2Visited: function (product) {
    const productData = {
      productID: product.id,
      title: product.title,
      handle: product.handle,
    };

    const productList = [];
    let jsonResp, jsonRespArr, jsonRespArrStr;
    const numberOfProducts = 20;

    productList.push(productData);
    const currProductPageTitle = productData.title;
    const productDataString = JSON.stringify(productList);
    const localData = localStorage.getItem("recentlyViewedProduct");

    if (localData === null) {
      localStorage.setItem("recentlyViewedProduct", productDataString);
    } else if (localData) {
      const oldProductData = localStorage.getItem("recentlyViewedProduct");
      const countProductData = (oldProductData.match(/productID/g) || [])
        .length;
      const sameProduct = oldProductData.includes(currProductPageTitle);

      if (countProductData < numberOfProducts && sameProduct == false) {
        jsonResp = JSON.parse(oldProductData);
        jsonRespArr = jsonResp.concat(productList);
        jsonRespArrStr = JSON.stringify(jsonRespArr);
        localStorage.setItem("recentlyViewedProduct", jsonRespArrStr);
      } else if (countProductData >= numberOfProducts && sameProduct == false) {
        jsonResp = JSON.parse(oldProductData);
        jsonResp.shift();
        jsonRespArr = jsonResp.concat(productList);
        jsonRespArr = JSON.stringify(jsonRespArr);
        localStorage.setItem("recentlyViewedProduct", jsonRespArr);
      }
    }
  },

  //-------------------------------------------------------------------------------------------------
  //	cart
  //-------------------------------------------------------------------------------------------------
  /**
   * @brief	initialization of the operation of the main elements of the shopping cart interface
   */
  initCartEvents: function () {
    // cart lines
    $("[data-cart-item-quantity_group] [data-type=minus]").on(
      "click",
      function (event) {
        event.preventDefault();
        shpCustom.setQuantity(this, -1);
      }
    );
    $("[data-cart-item-quantity_group] [data-type=plus]").on(
      "click",
      function (event) {
        event.preventDefault();
        shpCustom.setQuantity(this, 1);
      }
    );
    $("[data-cart-item-quantity_group] [data-type=remove], .cart-item__size-and-remove [data-type=remove]").on(
      "click",
      function (event) {
        event.preventDefault();
        shpCustom.cartItemRemove(this);
      }
    );
    $("[data-cart-item-quantity_group] [data-cart-item-quantity]").on(
      "change",
      function (event) {
        event.preventDefault();
        let productSection = $(this).parents("[data-cart-item]");
        shpCustom.cartItemUpdate(
          productSection.data("cart-item-key"),
          $(this).val()
        );
      }
    );
    $("[data-cart-item-variant_options]").on("change", function (event) {
      event.preventDefault();
      let productSection = $(this).parents("[data-cart-item]");
      let selectedOption = $(this).find(":selected"); // Get the selected option
      let getSellingPlanId = selectedOption.data("selling-plan");
      let selectedText = $(this).find(":selected").text();
      shpCustom.cartVariantUpdate(
        productSection.data("cart-item-key"),
        $(this).val(),
        getSellingPlanId,
        selectedText
      );
    });

    // cart properties
    $("[data-cart-attribute]").on("change", function (event) {
      event.preventDefault();
      shpCustom.cartAttributeUpdate(this);
    });
    $("[data-cart-note]").on("change", function (event) {
      event.preventDefault();
      shpCustom.cartUpdate($(this).val(), null);
    });
    if(window.cwCart)
    {
      $(".shpAddRecommended").on("click", function (event) {
        event.preventDefault();
        shpCustom.cartRecommendedAdd(this);
      });
    }
  },

  showCart: function () {
    $("body").trigger("shpShowCart");
    sessionStorage.removeItem("shpShowCart");
  },

  getCart: function () {
    let silentMode = arguments[0] === true;
    jQuery.getJSON("/cart.js", function (cart) {
      shpCustom.shpCart = cart;
      shpCustom.updateCartInfo();
      $(".shpProcessCartWait").hide();
      if (!silentMode) {
        shpCustom.showCart();
      }
    });
  },

  updateCartInfo: function (showCart) {
    let moneyFormat = shpTheme.money.moneyFormat + "";
    if(window.cwCart)
    {
      if (
        Object.hasOwn(shpCustom.shpCart, "sections") &&
        Object.hasOwn(shpCustom.shpCart.sections, "cw-api-cart_content")
      ) {
        $(".shpCartContent").html(
          $(shpCustom.shpCart.sections["cw-api-cart_content"]).html()
        );
        if($("#cwCart .recommended-products").length > 0)
        {
          $("#cwCart .recommended-products").html(
            $(".cw-recommended-products").html()
          );
          if($("body.a-b-test-collider-8 #cwCart.offcanvas .recommended-products .recommended-products__items .recommended-product").length > 0)
          {
            var $carousel = $("body.a-b-test-collider-8 #cwCart.offcanvas .recommended-products .recommended-products__items");
            if ($carousel.hasClass("slick-initialized")) 
            {
              $carousel.slick("unslick");
            }
            $carousel.slick({
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              dots: false,
              arrows: true,
            });
          }
        }
        shpCustom.initCartEvents();
      }
    }
    else
    {
      if (
        Object.hasOwn(shpCustom.shpCart, "sections") &&
        Object.hasOwn(shpCustom.shpCart.sections, "api-cart_content")
      ) {
        $(".shpCartContent").html(
          $(shpCustom.shpCart.sections["api-cart_content"]).html()
        );
        shpCustom.initCartEvents();
      }
    }
    

    // update summary data
    $(shpCustom.cartItemsValuePanel).html(
      moneyFormat.replace(
        "{{amount}}",
        numeral(shpCustom.shpCart.total_price / 100).format("0,0.00")
      )
    );

    // update cart status
    jQuery.getJSON("/cart.js", function (cart) {
      shpCustom.shpCart.item_count = cart.item_count;
      $(shpCustom.cartItemsCountPanel).text(shpCustom.shpCart.item_count);
      if (shpCustom.shpCart.item_count == 0) {
        $(".shpCartContent").addClass("empty");
      } else {
        $(".shpCartContent").removeClass("empty");
      }
    });

    $("body").trigger("updateCartInfo");

    if (showCart) {
      shpCustom.showCart();
    }
  },

  setQuantity: function (element, step) {
    let sectionContainer = $(element).parents(
      "[data-cart-item-quantity_group]"
    );
    if (!$(sectionContainer).hasClass("section-disabled")) {
      let sectionInput = $(sectionContainer).find('input[name="quantity"]');
      let sectionlabel = $(sectionContainer).find(
        "[data-cart-item-quantity_label]"
      );
      let productSection = $(element).parents("[data-cart-item]");

      let result = $(sectionInput).val() * 1 + step * 1;
      if (result * 1 <= 0) {
        result = 1;
      }
      $(sectionInput).val(result);

      if (result <= 1) {
        $(sectionContainer).find("[data-type=minus]").prop("disabled", true);
      } else {
        $(sectionContainer).find("[data-type=minus]").prop("disabled", false);
      }
      shpCustom.cartItemUpdate(productSection.data("cart-item-key"), result);

      if (result < 10) {
        result = "0" + result;
      }
      $(sectionlabel).text(result);
    }
  },

  cartItemRemove: function (element) {
    let productSection = $(element).parents("[data-cart-item]");
    let line_key = productSection.data("cart-item-key");
    const giftId = productSection.data("cart-item-gift-id");

    if (giftId) {
      $(".shpProcessCartWait").show();
      // Remove the beer and its gifts in a single update. A gift that another subscription
      // in the cart still earns stays put.
      $.getJSON("/cart.js", function (cart_data) {
        let updates = {};
        updates[line_key] = 0;
        let claimed = [];
        cart_data.items.forEach(function (item) {
          let marker = item.key !== line_key && item.properties && (item.properties._gift || item.properties.Gift);
          if (marker) {
            claimed = claimed.concat(String(marker).split(",").map(function (id) { return id.trim(); }));
          }
        });
        String(giftId).split(",").forEach(function (id) {
          id = id.trim();
          // Keep one if another subscription in the cart still earns it; otherwise take one away.
          // Extra copies (charged at full price) are removed first.
          let lines = cart_data.items.filter(function (item) {
            return String(item.variant_id) === id;
          }).sort(function (a, b) {
            return b.final_line_price - a.final_line_price;
          });
          let total = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
          let keep = Math.max(claimed.indexOf(id) !== -1 ? 1 : 0, total - 1);
          let toRemove = total - keep;
          lines.forEach(function (line) {
            if (toRemove <= 0) return;
            let current = line.key in updates ? updates[line.key] : line.quantity;
            let take = Math.min(current, toRemove);
            updates[line.key] = current - take;
            toRemove -= take;
          });
        });
        let sections = window.cwCart ? "cw-api-cart_content" : "api-cart_content";
        jQuery.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: { updates: updates, sections: sections },
          dataType: "json",
          success: function (success_data) {
            shpCustom.shpCart = success_data;
            shpCustom.updateCartInfo();
          },
          error: function (error_data) {
            shpCustom.cartUpdateError(error_data);
          },
        });
      }).fail(function (error_data) {
        shpCustom.cartUpdateError(error_data);
      });
    } else {
      shpCustom.cartItemUpdate(productSection.data("cart-item-key"), 0);
    }
  },

  cartAddBeerWithGifts: function (element, beerItem, gift_ids, do_reload) {
    // Beer and its free gifts go in one request: Shopify adds all of them or none, so a
    // rejected beer can never leave a gift behind at full price.
    let sectionPrefix = window.cwCart ? "cw-" : "";
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: [beerItem].concat(
          gift_ids.map(function (id) {
            return { id: id, quantity: 1 };
          })
        ),
        sections: sectionPrefix + "api-cart_content," + sectionPrefix + "api-cart_summary",
      },
      dataType: "json",
      success: function (success_data) {
        if (do_reload) {
          if (!sessionStorage.getItem("isReloading")) {
            sessionStorage.setItem("isReloading", "true");
            sessionStorage.setItem("shpShowCart", true);
            window.location.reload();
          }
        } else {
          if (shpCustom.shpCart) {
            shpCustom.shpCart["sections"] = success_data["sections"];
          } else {
            shpCustom.shpCart = {
              sections: success_data["sections"],
            };
          }
          let dataSet = $(shpCustom.shpCart.sections[sectionPrefix + "api-cart_summary"])
            .find("#cart_summary")
            .data();
          for (const key in dataSet) {
            if (dataSet.hasOwnProperty(key)) {
              shpCustom.shpCart[key] = dataSet[key];
            }
          }

          shpCustom.updateCartInfo(true);
        }
      },
      error: function (error_data) {
        shpCustom.cartUpdateError(error_data);
      },
      complete: function () {
        $(element).prop("disabled", false);
        $(".shpProcessCartWait").hide();
      },
    });
  },

  cartItemAdd: function (element) {
    let variant_id, gift_id, variant_quantity, selling_plan, do_reload;
    let properties = {};

    if ($(element).data("variant_id") != undefined) {
      variant_id = $(element).data("variant_id");
      variant_quantity =
        $(element).data("quantity") !== undefined
          ? $(element).data("quantity")
          : 1;
      selling_plan = $(element).data("selling_plan");
      do_reload =
        $(element).data("reload") !== undefined && $(element).data("reload");

      if ($(element).data("item_property") != undefined) {
        let property = $(element).data("item_property").split("|");
        properties[property[0]] = property[1];
      }
    } else {
      let cartForm = $(element).parents("form");
      variant_id = $(cartForm).find('input[name="id"]').val();
      variant_quantity = $(cartForm).find('input[name="quantity"]').val() || 1;
      selling_plan = $(cartForm).find('input[name="selling_plan"]').val();
      gift_id = $(cartForm).find('input[name="gift_id"]').val();

      $(cartForm)
        .find('input[name^="properties"]')
        .each(function () {
          if ($(this).val()) {
            let text = $(this).attr("name");
            let propertyName = text
              .substr(0, text.length - 1)
              .replace("properties[", "");
            properties[propertyName] = $(this).val();
          }
        });

      if (gift_id) {
        properties["_gift"] = gift_id;
      }
    }

    $(".shpProcessCartWait").show();
    $(element).prop("disabled", true);

    if (gift_id) {
      // A gift that is already in the cart is not added again: only one free gift of each
      // kind is discounted per order, so a second one would be charged at full price.
      let gift_ids = String(gift_id).split(",").filter(Boolean);
      let beerItem = { id: variant_id, quantity: variant_quantity || 1, properties: properties };
      if (selling_plan) {
        beerItem.selling_plan = selling_plan;
      }
      $.getJSON("/cart.js", function (cart_data) {
        let inCart = cart_data.items.map(function (item) {
          return String(item.variant_id);
        });
        shpCustom.cartAddBeerWithGifts(element, beerItem, gift_ids.filter(function (id) {
          return inCart.indexOf(String(id).trim()) === -1;
        }), do_reload);
      }).fail(function () {
        shpCustom.cartAddBeerWithGifts(element, beerItem, gift_ids, do_reload);
      });
    } else {
      if(window.cwCart)
      {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: variant_id,
            quantity: variant_quantity || 1,
            selling_plan: selling_plan,
            properties: properties,
            sections: "cw-api-cart_content,cw-api-cart_summary",
          },
          dataType: "json",
          success: function (success_data) {
            if (do_reload) {
              if (!sessionStorage.getItem("isReloading")) {
                sessionStorage.setItem("isReloading", "true");
                sessionStorage.setItem("shpShowCart", true);
                window.location.reload();
              }
            } else {
              if (shpCustom.shpCart) {
                shpCustom.shpCart["sections"] = success_data["sections"];
              } else {
                shpCustom.shpCart = {
                  sections: success_data["sections"],
                };
              }
              let dataSet = $(shpCustom.shpCart.sections["api-cart_summary"])
                .find("#cart_summary")
                .data();
              for (const key in dataSet) {
                if (dataSet.hasOwnProperty(key)) {
                  shpCustom.shpCart[key] = dataSet[key];
                }
              }

              shpCustom.updateCartInfo(true);
            }
          },
          error: function (error_data) {
            shpCustom.cartUpdateError(error_data);
          },
          complete: function () {
            $(element).prop("disabled", false);
            $(".shpProcessCartWait").hide();
          },
        });
      }
      else
      {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: variant_id,
            quantity: variant_quantity || 1,
            selling_plan: selling_plan,
            properties: properties,
            sections: "api-cart_content,api-cart_summary",
          },
          dataType: "json",
          success: function (success_data) {
            if (do_reload) {
              if (!sessionStorage.getItem("isReloading")) {
                sessionStorage.setItem("isReloading", "true");
                sessionStorage.setItem("shpShowCart", true);
                window.location.reload();
              }
            } else {
              if (shpCustom.shpCart) {
                shpCustom.shpCart["sections"] = success_data["sections"];
              } else {
                shpCustom.shpCart = {
                  sections: success_data["sections"],
                };
              }
              let dataSet = $(shpCustom.shpCart.sections["api-cart_summary"])
                .find("#cart_summary")
                .data();
              for (const key in dataSet) {
                if (dataSet.hasOwnProperty(key)) {
                  shpCustom.shpCart[key] = dataSet[key];
                }
              }

              shpCustom.updateCartInfo(true);
            }
          },
          error: function (error_data) {
            shpCustom.cartUpdateError(error_data);
          },
          complete: function () {
            $(element).prop("disabled", false);
            $(".shpProcessCartWait").hide();
          },
        });
      }
    }
  },

  cartRecommendedAdd: function (element) {
    let variant_id, variant_quantity, selling_plan, do_reload;
    let properties = {};

    if ($(element).data("variant_id") != undefined) {
      // all data are attached to AddToBag button (product list case)
      variant_id = $(element).data("variant_id");
      variant_quantity =
        $(element).data("quantity") != undefined
          ? $(element).data("quantity")
          : 1;
      selling_plan = $(element).data("selling_plan");
      do_reload =
        $(element).data("reload") != undefined && $(element).data("reload");

      if ($(element).data("item_property") != undefined) {
        let property = $(element).data("item_property").split("|");
        properties[property[0]] = property[1];
      }
    } else {
      // all data are attached to parent form (product page case)
      let cartForm = $(element).parents("form");
      variant_id = $(cartForm).find('input[name="id"]').val();
      variant_quantity = $(cartForm).find('input[name="quantity"]').val();
      selling_plan = $(cartForm).find('input[name="selling_plan"]').val();

      $(cartForm)
        .find('input[name^="properties"]')
        .each(function () {
          if ($(this).val()) {
            let text = $(this).attr("name");
            let propertyName = text
              .substr(0, text.length - 1)
              .replace("properties[", "");
            properties[propertyName] = $(this).val();
          }
        });
    }

    $(".shpProcessCartWait").show();
    $(element).prop("disabled", true);
    if(window.cwCart)
    {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variant_id,
          quantity: (variant_quantity = variant_quantity || 1),
          selling_plan: selling_plan,
          properties: properties,
          sections: "cw-api-cart_content,cw-api-cart_summary",
        },
        dataType: "json",
        success: function (success_data) {
          if (do_reload) {
            // if cart should be shown AFTER reload
            sessionStorage.setItem("shpShowCart", true);
            window.location.reload();
          } else {
            if (shpCustom.shpCart) {
              shpCustom.shpCart["sections"] = success_data["sections"];
            } else {
              shpCustom.shpCart = {
                sections: success_data["sections"],
              };
            }
            let dataSet = $(shpCustom.shpCart.sections["cw-api-cart_summary"])
              .find("#cart_summary")
              .data();
            for (const key in dataSet) {
              if (dataSet.hasOwnProperty(key)) {
                shpCustom.shpCart[key] = dataSet[key];
              }
            }
            shpCustom.updateCartInfo(true);
          }
        },
        error: function (error_data, error_type) {
          shpCustom.cartUpdateError(error_data);
        },
        complete: function () {
          $(element).prop("disabled", false);
          $(".shpProcessCartWait").hide();
        },
      });
    }
    else
    {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variant_id,
          quantity: (variant_quantity = variant_quantity || 1),
          selling_plan: selling_plan,
          properties: properties,
          sections: "api-cart_content,api-cart_summary",
        },
        dataType: "json",
        success: function (success_data) {
          if (do_reload) {
            // if cart should be shown AFTER reload
            sessionStorage.setItem("shpShowCart", true);
            window.location.reload();
          } else {
            if (shpCustom.shpCart) {
              shpCustom.shpCart["sections"] = success_data["sections"];
            } else {
              shpCustom.shpCart = {
                sections: success_data["sections"],
              };
            }
            let dataSet = $(shpCustom.shpCart.sections["api-cart_summary"])
              .find("#cart_summary")
              .data();
            for (const key in dataSet) {
              if (dataSet.hasOwnProperty(key)) {
                shpCustom.shpCart[key] = dataSet[key];
              }
            }
            shpCustom.updateCartInfo(true);
          }
        },
        error: function (error_data, error_type) {
          shpCustom.cartUpdateError(error_data);
        },
        complete: function () {
          $(element).prop("disabled", false);
          $(".shpProcessCartWait").hide();
        },
      });
    }
    
  },

  cartItemUpdate: function (
    line_key,
    new_quantity,
    new_selling_plan,
    new_properties
  ) {
    if(window.cwCart)
    {
      var data2change = { id: line_key, sections: "cw-api-cart_content" };
    }
    else
    {
      var data2change = { id: line_key, sections: "api-cart_content" };
    }
    
    if (new_quantity !== null) {
      data2change["quantity"] = new_quantity;
    }
    if (new_selling_plan !== null) {
      data2change["selling_plan"] = new_selling_plan;
    }
    if (new_properties !== null) {
      data2change["properties"] = new_properties;
    }
    $(".shpProcessCartWait").show();

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data2change,
      dataType: "json",
      success: function (success_data) {
        if (new_quantity == 0) {
          $('[data-cart-item-key="' + line_key + '"]').remove();
        } else if (success_data.items) {
          // check if update succeded
          $.each(success_data.items, function (index, item) {
            if (line_key == item.key) {
              if (new_quantity > item.quantity) {
                shpCustom.showInfo(
                  shpTheme.strings.cartUpdateUnsuccessful,
                  shpTheme.strings.productInventoryLevelTooLow
                );
              }
            }
          });
        }
        shpCustom.shpCart = success_data;
        shpCustom.updateCartInfo();
      },
      error: function (error_data, error_type) {
        shpCustom.cartUpdateError(error_data);
      },
      complete: function () {},
    });
  },

  cartVariantUpdate: function (line_key, new_variant, selling_plan = null, selectedText = null) {
    $(".shpProcessCartWait").show();
    if(window.cwCart)
    {
      if(selling_plan != "undefined" && selling_plan != null && selling_plan != "" && selectedText != "undefined" && selectedText != null && selectedText != "")
      {
        var free_gift_variant_id = "";
        let cartData = {}; // will hold new items

        if (selectedText == "24 Pack") {
          free_gift_variant_id = 55265733869942;
          let mainProperties = {};
          mainProperties["_gift"] = free_gift_variant_id;

          cartData = {
            items: [
              {
                id: new_variant,
                quantity: 1,
                selling_plan: selling_plan,
                properties: mainProperties
              },
              {
                id: free_gift_variant_id,
                quantity: 1
              }
            ],
            sections: "cw-api-cart_content,cw-api-cart_summary"
          };
        }
        else if (selectedText == "48 Pack") {
          let gift_variant_ids_48 = [55265733869942, 58552052941174];
          free_gift_variant_id = gift_variant_ids_48.join(",");
          let mainProperties = {};
          mainProperties["_gift"] = free_gift_variant_id;

          cartData = {
            items: [
              {
                id: new_variant,
                quantity: 1,
                selling_plan: selling_plan,
                properties: mainProperties
              },
              {
                id: gift_variant_ids_48[0],
                quantity: 1
              },
              {
                id: gift_variant_ids_48[1],
                quantity: 1
              }
            ],
            sections: "cw-api-cart_content,cw-api-cart_summary"
          };
        }
        else if (selectedText == "12 Pack") {
          cartData = {
            items: [
              {
                id: new_variant,
                quantity: 1,
                selling_plan: selling_plan
              }
            ],
            sections: "cw-api-cart_content,cw-api-cart_summary"
          };
        }

        $.getJSON('/cart.json', function (cart_data) {
          var giftKeys = [];
          $.each(cart_data.items, function (index, item) {
            if (item.key === line_key) {
              let giftMarker = item.properties && (item.properties._gift || item.properties.Gift);
              if (giftMarker) {
                let giftVariantIds = String(giftMarker).split(",");
                $.each(cart_data.items, function (i, giftItem) {
                  if (giftVariantIds.indexOf(String(giftItem.variant_id)) !== -1) {
                    giftKeys.push(giftItem.key);
                  }
                });
              }
              if (giftKeys.length)
              {
                let updates = {};
                updates[line_key] = 0;
                $.each(giftKeys, function (i, giftKey) {
                  updates[giftKey] = 0;
                });

                // Remove both with /cart/update.js
                $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  data: { updates: updates },
                  dataType: "json",
                  success: function () {
                    // Now add new variant(s)
                    $.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: cartData,
                      dataType: "json",
                      success: function (success_data) {
                        shpCustom.shpCart = success_data;
                        shpCustom.updateCartInfo();
                      },
                      error: function (error_data) {
                        shpCustom.cartUpdateError(error_data);
                      }
                    });
                  },
                  error: function (error_data) {
                    shpCustom.cartUpdateError(error_data);
                  }
                });

              } 
              else 
              {
                // CASE 2: Only parent exists
                let updates = {};
                updates[line_key] = 0;

                // Remove old parent
                $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  data: { updates: updates },
                  dataType: "json",
                  success: function () {
                    $.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: cartData,
                      dataType: "json",
                      success: function (success_data) {
                        shpCustom.shpCart = success_data;
                        shpCustom.updateCartInfo();
                      },
                      error: function (error_data) {
                        shpCustom.cartUpdateError(error_data);
                      }
                    });
                  },
                  error: function (error_data) {
                    shpCustom.cartUpdateError(error_data);
                  }
                });
              }
            }
          });
        });
      }
      else
      {
        if(selling_plan != "undefined" && selling_plan != null && selling_plan != "")
        {
          var cartData = {
            id: new_variant,           
            quantity: 1,               
            selling_plan: selling_plan, 
            sections: "cw-api-cart_content,cw-api-cart_summary",
          };
        }
        else
        {
          var cartData = {
            id: new_variant,           
            quantity: 1,               
            sections: "cw-api-cart_content,cw-api-cart_summary",
          };
        }
        jQuery.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: line_key,
            quantity: 0,
            sections: "cw-api-cart_content",
          },
          dataType: "json",
          success: function () {
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: cartData,
              dataType: "json",
              success: function (success_data) {
                shpCustom.shpCart = success_data;
                shpCustom.updateCartInfo();
              },
              error: function (error_data) {
                shpCustom.cartUpdateError(error_data);
              },
            });
          },

          error: function (error_data) {
            shpCustom.cartUpdateError(error_data);
          },
        });
      }
    }
    else
    {
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
          id: line_key,
          quantity: 0,
          sections: "api-cart_content",
        },
        dataType: "json",
        success: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: new_variant,
              quantity: 1,
              sections: "api-cart_content,api-cart_summary",
            },
            dataType: "json",
            success: function (success_data) {
              shpCustom.shpCart = success_data;
              shpCustom.updateCartInfo();
            },
            error: function (error_data) {
              shpCustom.cartUpdateError(error_data);
            },
          });
        },

        error: function (error_data) {
          shpCustom.cartUpdateError(error_data);
        },
      });
    }
    
  },

  cartAttributeUpdate: function (element) {
    let elementValue;
    if (element != undefined && !$(element).data("disable_events")) {
      let elementName = $(element).attr("name");
      let elementForm = $(element).parents("form");
      if (
        $(element).attr("type") == "checkbox" ||
        $(element).attr("type") == "radio"
      ) {
        elementValue = $('[name="' + elementName + '"]:checked').val();
      } else {
        elementValue = $('[name="' + elementName + '"]').val();
      }

      let attributes = {};
      $(elementForm)
        .find("[data-cart-attribute]")
        .each(function () {
          let thisName = $(this).attr("name");
          let thisValue;

          if (
            $(this).attr("type") == "checkbox" ||
            $(this).attr("type") == "radio"
          ) {
            thisValue = $(elementForm)
              .find('[name="' + thisName + '"]:checked')
              .val();
          } else {
            thisValue = $(elementForm)
              .find('[name="' + thisName + '"]')
              .val();
          }
          if (thisValue != undefined && thisValue != "") {
            attributes[$(this).data("cart-attribute")] = thisValue;
          } else {
            attributes[$(this).data("cart-attribute")] = null;
          }
      });
      if(window.cwCart)
      {
        jQuery.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
            attributes: attributes,
            sections: "cw-api-cart_content",
          },
          dataType: "json",
          success: function (success_data) {
            shpCustom.shpCart = success_data;
            shpCustom.updateCartInfo();
          },
          error: function (error_data, error_type) {
            shpCustom.cartUpdateError(error_data);
          },
          complete: function () {
            $(".shpProcessCartWait").hide();
          },
        });
      }
      else
      {
        jQuery.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
            attributes: attributes,
            sections: "api-cart_content",
          },
          dataType: "json",
          success: function (success_data) {
            shpCustom.shpCart = success_data;
            shpCustom.updateCartInfo();
          },
          error: function (error_data, error_type) {
            shpCustom.cartUpdateError(error_data);
          },
          complete: function () {
            $(".shpProcessCartWait").hide();
          },
        });
      }
    }
  },

  cartUpdate: function (cart_note, cart_attributes) {
    if(window.cwCart)
    {
      var data2change = { sections: "cw-api-cart_content" };
    }
    else
    {
      var data2change = { sections: "api-cart_content" };
    }
    if (cart_note !== null) {
      data2change["note"] = cart_note;
    }
    if (cart_note !== null) {
      data2change["attributes"] = cart_attributes;
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data2change,
      dataType: "json",
      success: function (success_data) {
        shpCustom.shpCart = success_data;
        shpCustom.updateCartInfo();
      },
      error: function (error_data, error_type) {
        shpCustom.cartUpdateError(error_data);
      },
      complete: function () {
        $(".shpProcessCartWait").hide();
      },
    });
  },

  cartUpdateSuccess: function (success_data, sucess_info) {},

  cartUpdateError: function (error_data) {
    $(".shpProcessCartWait").hide();
    let error_info = (error_data && error_data.responseJSON) || {};
    shpCustom.showInfo(
      error_info.message || "Sorry",
      error_info.description || "We couldn't update your cart. Please try again."
    );
    shpCustom.refreshCartDrawer();
  },

  refreshCartDrawer: function () {
    let sections = window.cwCart ? "cw-api-cart_content" : "api-cart_content";
    jQuery.getJSON("/cart.js", function (cart) {
      jQuery.getJSON("/?sections=" + sections, function (rendered) {
        cart.sections = rendered;
        shpCustom.shpCart = cart;
        shpCustom.updateCartInfo();
        $(".shpProcessCartWait").hide();
      });
    });
  },

  //-------------------------------------------------------------------------------------------------
  //	other
  //-------------------------------------------------------------------------------------------------
  calculateFS: function () {
    console.log("calculateFS");

    $("[data-free_shipment]").each(function () {
      let fsObj = $(this);
      let fsObjLevel = fsObj.find("[data-free_shipment_level]");
      let fsObjCountry = fsObjLevel.data("free_shipment_country");

      if (
        fsObjLevel.data("free_shipment_level") != undefined &&
        fsObjLevel.data("free_shipment_level") > 0 &&
        $("[data-cart-subtotal]").attr("data-cart-subtotal") != undefined &&
        $("[data-cart-subtotal]").attr("data-cart-subtotal") >= 0
      ) {
        let moneyFormat = shpTheme.money.moneyFormat + "";
        let cart_value =
          $("[data-cart-subtotal]").attr("data-cart-subtotal") * 1;
        if (fsObjLevel.data("free_shipment_virtual") * 1 > 0) {
          cart_value =
            cart_value + fsObjLevel.data("free_shipment_virtual") * 1;
        }

        let left_2_free_shipment =
          fsObjLevel.data("free_shipment_level") - cart_value;

        let info, percentage;
        if (left_2_free_shipment > 0) {
          if (
            fsObj.data("free_shipment_missing") != "" &&
            Object.hasOwn(shpTheme.strings, fsObj.data("free_shipment_missing"))
          ) {
            info = shpTheme.strings[fsObj.data("free_shipment_missing")] + "";
          } else {
            info = shpTheme.strings.free_shipment_missing + "";
          }
          info = info.replace(
            "{{value}}",
            moneyFormat.replace(
              "{{amount}}",
              numeral(left_2_free_shipment).format("0,0.00")
            )
          );

          percentage = Math.round(
            100 * (cart_value / fsObjLevel.data("free_shipment_level"))
          );

          fsObj.removeClass("free_shipping_achieved");
        } else {
          if (
            fsObj.data("free_shipment_unlocked") != "" &&
            Object.hasOwn(
              shpTheme.strings,
              fsObj.data("free_shipment_unlocked")
            )
          ) {
            info = shpTheme.strings[fsObj.data("free_shipment_unlocked")] + "";
          } else {
            info = shpTheme.strings.free_shipment_unlocked + "";
          }
          info = info.replace(
            "{{value}}",
            moneyFormat.replace(
              "{{amount}}",
              numeral(fsObjLevel.data("free_shipment_level")).format("0,0.00")
            )
          );
          percentage = 100;

          fsObj.addClass("free_shipping_achieved");
        }
        info = info.replace("{{country}}", fsObjCountry);
        fsObjLevel.html(info);

        fsObj.find(".progress-bar").attr("aria-valuenow", percentage);
        fsObj.find(".progress-bar").attr("style", "width:" + percentage + "%");
      } else {
        fsObj.hide();
      }
    });
  },

  initSellingPlanElements: function () {
    // set free gift id
    let variantName = $(`.variant-item.current input`).data("option-name");
    let freeGiftId = $(".js-product-gift")
      .filter(function () {
        return Number($(this).data("related-variant")) <= Number(variantName);
      })
      .map(function () {
        return $(this).data("free-gift-id");
      })
      .get()
      .filter(function (id) {
        return id !== undefined && id !== null && id !== "";
      })
      .join(",");

    $("#product-object input[name=gift_id]").val(freeGiftId);

    $("#selling-plan-select details").on("click", function (event) {
      if ($(this).prop("open")) {
        event.preventDefault();
        $(this).prop("open", false);
      }
    });

    $(document).on("click", "#selling-plan-select details", function () {
      $(this).prop("open", false);
    });

    $(document).on("click", function (e) {
      if (!$(e.target).closest("#selling-plan-select details").length) {
        $("#selling-plan-select details").prop("open", false);
      }
    });

    if (
      $("#product-object input[name=selling_plan]").val() == "" &&
      $(".subscribe[data-default-plan-id]").length > 0
    ) {
      $("#product-object input[name=selling_plan]").val(
        $(".subscribe[data-default-plan-id]").data("default-plan-id")
      );
    }

    let current_plan_price = $("#subscribe .single-offer.active .plan-price");

    $(".shpAdd2CartButton [data-default-price]").each(function () {
      if ($("#subscribe .single-offer.active .plan-price").length > 0) {
        $(this).html(current_plan_price.html());
        $(this)
          .attr("data-current_price_value", current_plan_price.data("value"))
          .data("current_price_value", current_plan_price.data("value"));
      }
      $("[data-free_shipment_virtual]")
        .attr(
          "data-free_shipment_virtual",
          $(".shpAdd2CartButton [data-current_price_value]").attr(
            "data-current_price_value"
          )
        )
        .data(
          "free_shipment_virtual",
          $(".shpAdd2CartButton [data-current_price_value]").attr(
            "data-current_price_value"
          )
        );
      // shpCustom.calculateFS();
    });

    $(".js-new-subscribe-price").html(current_plan_price.html());

    $("#product-object .single-offer").on("click", function (e) {
      $(this).addClass("active").siblings().removeClass("active");
      $("#product-object input[name=selling_plan]").val(
        $(this).data("selling-plan-id")
      );
      $("#selected-selling-plan").text($(this).data("plan-name"));
      $(".shpAdd2CartButton [data-default-price]").each(function () {
        let current_plan_price = $(
          "#subscribe .single-offer.active .plan-price"
        );
        $(this).html(current_plan_price.html());
        $(this)
          .attr("data-current_price_value", current_plan_price.data("value"))
          .data("current_price_value", current_plan_price.data("value"));
      });
      // $('[data-free_shipment_virtual]').attr('data-free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value')).data('free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value'))
      // shpCustom.calculateFS();
    });

    $("#subscribe-tabSelector button").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(".js-subscribe-modal").removeClass("d-none");
        $(".js-subscribe-gift").addClass("disabled");
        $(".js-selling-plan-promo").addClass("d-none");
        $(".js-compare-price-promo").removeClass("d-none");
        shpCustom.updateGiftsAndDiscounts();
        $("#product-object input[name=selling_plan]").val("");
        $("#product-object input[name=gift_id]").val("");
        $(".shpAdd2CartButton [data-default-price]").each(function () {
          $(this).html($(this).data("default-price"));
          $(this)
            .attr(
              "data-current_price_value",
              $(this).data("default-price_value")
            )
            .data("current_price_value", $(this).data("default-price_value"));
        });
        $(".js-subscribe-price").addClass("d-none");
      }
      // $('[data-free_shipment_virtual]').attr('data-free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value')).data('free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value'))
      // shpCustom.calculateFS();
    });
    $(".js-subscribe-modal").on("click", function () {
      $(this).addClass("d-none");
      $("#subscribe-tabSelector button").addClass("active");
      shpCustom.updateGiftsAndDiscounts();
      $(".js-selling-plan-promo").removeClass("d-none");
      $(".js-compare-price-promo").addClass("d-none");
      $("#product-object input[name=selling_plan]").val(
        $("#subscribe .single-offer.active").data("selling-plan-id")
      );
      $("#product-object input[name=gift_id]").val(freeGiftId);
      $(".shpAdd2CartButton [data-default-price]").each(function () {
        let current_plan_price = $(
          "#subscribe .single-offer.active .plan-price"
        );
        $(this).html(current_plan_price.html());
        $(this)
          .attr("data-current_price_value", current_plan_price.data("value"))
          .data("current_price_value", current_plan_price.data("value"));
      });
      $(".js-subscribe-price").removeClass("d-none");
    });
  },
};

$(document).ready(function () {
  shpCustom.init();

  let doc_width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (!shpCustom.getCookie("newsletter_box_modal") && doc_width <= 768) {
    $("#NewsletterModal").on("hidden.bs.modal", function (event) {
      shpCustom.setCookie("newsletter_box_modal", 1); // close Newsletter window for current session
    });
    setTimeout(function () {
      $("#NewsletterModal").modal("show");
    }, 1000);
  }

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());

  if ($(".happy-science").length > 0) {
    let accordionExists = false;
    $("[data-button2do]").each(function () {
      let identifier = $(this).data("button2do");
      if (identifier) {
        if ($('[data-accordion2do="' + identifier + '"]').length > 0) {
          if (!accordionExists) {
            $(".happy-science").after(
              '<div class="adaptogens-content"><div class="container"><div class="row"><div class="col-md-12"><div class="accordion" id="accordionPositions"></div></div></div></div></div>'
            );
            accordionExists = true;
          }
          let item = $("[data-accordion2do=" + identifier + "]").detach();
          item.appendTo("#accordionPositions");

          $("#accordionPositions")
            .find(".accordion-item")
            .removeClass("d-none");

          $(this)
            .attr("data-bs-toggle", "collapse")
            .data("bs-toggle", "collapse");
          $(this).attr("href", "#collapse-" + identifier);
          $(this).on("click", function (event) {
            shpCustom.scrollToElement(
              '[data-bs-target="#collapse-' + identifier + '"]'
            );
          });

          let goto = urlParams["goto"];
          if (goto == identifier) {
            $(this).click();
            $('button[data-bs-target="#collapse-' + identifier + '"]').click();
          }
        }
      }
    });
  }

  if ($(".mood-boosting-blend").length > 0) {
    let accordionExists = false;

    $(".accordion-section .accordion-item[data-accordion2do]").each(function () {
      const $item = $(this);

      if (!accordionExists) {
        $(".mood-boosting-blend").after(
          '<div class="adaptogens-content">' +
          '<div class="container">' +
          '<div class="row">' +
          '<div class="col-md-12">' +
          '<div class="accordion" id="accordionPositions"></div>' +
          "</div>" +
          "</div>" +
          "</div>" +
          "</div>"
        );
        accordionExists = true;
      }

      $item
        .detach()
        .appendTo("#accordionPositions")
        .removeClass("d-none");
    });
  }

  if ($(".visualiser-section").length > 0) {
    $("button[data-audio_src]").on("click", function (event) {
      event.preventDefault();
      let soundURL = $(this).data("audio_src"),
        audio = document.getElementById("audio");
      if (soundURL != "" && audio != undefined) {
        audio.setAttribute("src", soundURL);
        audio.play();
        $("button.stop-music").addClass("playing");
      }
    });

    $("button.stop-music").on("click", function (event) {
      event.preventDefault();
      let audio = document.getElementById("audio");
      if (audio != undefined) {
        if ($(this).hasClass("playing")) {
          audio.pause();
          $(this).removeClass("playing");
        } else {
          audio.play();
          $(this).addClass("playing");
        }
      }
    });

    console.log("show_on_start", $("#visualiserModal").data("show_on_start"));
    if ($("#visualiserModal").data("show_on_start") == true) {
      console.log("open-modal");
      $("#visualiserModal").modal("show");
    }
  }

  $("body").on("updateVariantInfo", function (event) {
    shpCustom.initSellingPlanElements();
  });
  shpCustom.initSellingPlanElements();

  $("body").on("updateCartInfo", function (event) {
    if ($("body.cart-page").length > 0) {
      window.location.reload();
    } else {
      $(".shpCartItemsList .cart-item")
        .not(".shpCartLineTemplate")
        .each(function () {
          $(this)
            .find("select[data-cart-item-quantity]")
            .each(function () {
              if (!$(this).val() && $(this).data("cart-item-quantity") > 0) {
                $(this).append(
                  "<option selected>" +
                    $(this).data("cart-item-quantity") +
                    "</option>"
                );
              }
            });

          $(this)
            .find("select.pre-select")
            .removeClass("pre-select")
            .addClass("select");
        });
      $(" .select").select2({
        minimumResultsForSearch: Infinity,
      });
      $(".dropdown-select").select2({
        minimumResultsForSearch: Infinity,
        dropdownCssClass: "subscribe-dropdown",
      });
      // shpCustom.calculateFS();
    }
  });
  // shpCustom.calculateFS();

  $("body").on("shpShowCart", function (event) { 
    if(window.cwCart)
    {
      if ($("#cwCart").siblings(".offcanvas-backdrop").length == 0) {
        var cartOffcanvas = new bootstrap.Offcanvas("#cwCart");
        cartOffcanvas.show();
      }
    }
    else
    {
      if ($("#cart").siblings(".offcanvas-backdrop").length == 0) {
        var cartOffcanvas = new bootstrap.Offcanvas("#cart");
        cartOffcanvas.show();
      }
    }
  });

  $("#accepts_regulations").on("change", function () {
    if ($(this).prop("checked") != true) {
      $(this)
        .parents("form")
        .find("button[type=submit]")
        .prop("disabled", true);
    } else {
      $(this)
        .parents("form")
        .find("button[type=submit]")
        .prop("disabled", false);
    }
  });
});
